import { LocaleData } from '../locales/types';

export class EmailSupport {
    private backdrop: HTMLDivElement;
    private card: HTMLDivElement;

    constructor(
        private options: {
            onClose: () => void;
            t: (key: keyof LocaleData) => string;
            direction?: 'ltr' | 'rtl';
        }
    ) {
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'modal-backdrop modal-backdrop-top';
        this.backdrop.onclick = this.options.onClose;

        this.card = document.createElement('div');
        this.card.className = 'modal-card support-modal-card';
        if (this.options.direction) {
            this.card.dir = this.options.direction;
        }
        this.card.onclick = (e) => e.stopPropagation();

        const closeBtn = document.createElement('button');
        closeBtn.className = 'modal-close-x';
        closeBtn.onclick = this.options.onClose;
        closeBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        `;
        this.card.appendChild(closeBtn);

        const header = document.createElement('h2');
        header.className = 'modal-header';
        header.textContent = this.options.t('support_title');
        this.card.appendChild(header);

        const form = document.createElement('form');
        form.className = 'support-form';

        const subjectGroup = document.createElement('div');
        subjectGroup.className = 'form-group';

        const subjectLabel = document.createElement('label');
        subjectLabel.textContent = this.options.t('support_subject_label');

        const subjectInput = document.createElement('input');
        subjectInput.type = 'text';
        subjectInput.required = true;
        subjectInput.className = 'support-input';

        subjectGroup.appendChild(subjectLabel);
        subjectGroup.appendChild(subjectInput);

        const messageGroup = document.createElement('div');
        messageGroup.className = 'form-group';

        const messageLabel = document.createElement('label');
        messageLabel.textContent = this.options.t('support_message_label');

        const messageInput = document.createElement('textarea');
        messageInput.required = true;
        messageInput.rows = 5;
        messageInput.className = 'support-textarea';

        messageGroup.appendChild(messageLabel);
        messageGroup.appendChild(messageInput);

        const submitBtn = document.createElement('button');
        submitBtn.type = 'submit';
        submitBtn.className = 'modal-btn btn-gradient';
        submitBtn.textContent = this.options.t('support_submit_button');
        submitBtn.style.marginTop = '10px';

        const hint = document.createElement('p');
        hint.className = 'support-hint';
        hint.style.fontSize = '12px';
        hint.style.color = '#8b949e';
        hint.style.marginBottom = '10px';
        hint.textContent = this.options.t('support_hint');

        form.appendChild(subjectGroup);
        form.appendChild(messageGroup);
        form.appendChild(hint);
        form.appendChild(submitBtn);

        form.onsubmit = (e) => {
            e.preventDefault();
            const email = (import.meta as any).env.VITE_EMAIL_SUPPORT || 'support@argvoid.com';
            const subject = encodeURIComponent(subjectInput.value);
            const body = encodeURIComponent(messageInput.value);

            // Try to open email client
            const mailtoUrl = `mailto:${email}?subject=${subject}&body=${body}`;
            window.location.assign(mailtoUrl);

            // Close the current modal
            this.options.onClose();
        };

        this.card.appendChild(form);
        this.backdrop.appendChild(this.card);

        this.handleEsc = this.handleEsc.bind(this);
        document.addEventListener('keydown', this.handleEsc);
    }

    private handleEsc(e: KeyboardEvent) {
        if (e.key === 'Escape') this.options.onClose();
    }

    public getElement() {
        return this.backdrop;
    }

    public destroy() {
        document.removeEventListener('keydown', this.handleEsc);
        this.backdrop.remove();
    }
}
